<div class="shop">
  <section>
    <div class="title" i18n="@@getTreatmentKitFor">Get a treatment kit for</div>
    <regimen-concern-selection (selectConcern)="onSelectConcern($event)" [gender]="user?.get('Gender')"></regimen-concern-selection>
  </section>
  @if (user?.isPaid()) {
    <section>
      <div class="header">
        <div class="title" i18n="@@recommProducts">Recommended products</div>
        <div class="title float-right" (click)="viewAll('recommendedProducts')"><span i18n="@@viewAll">View all</span></div>
      </div>
      @if (isAddOnProductLoading$ | async) {
        <loading class="pos-abs vh-center"></loading>
        }@if (!(isAddOnProductLoading$ | async) && !(addOnProducts$ | async)?.length) {
        <div *ngTemplateOutlet="notFound"></div>
        }@if ((addOnProducts$ | async)?.length) {
        <product-carousel [products]="addOnProducts$ | async"></product-carousel>
      }
    </section>
  }
  @if (user?.isPaid() && ((isReorderProductLoading$ | async) || (reorderProducts$ | async)?.length)) {
    <section>
      <div class="header">
        <div class="title" i18n="@@treatmentProducts">Treatment Kit Products</div>
        <div class="title float-right" (click)="viewAll('reorderProducts')"><span i18n="@@viewAll">View all</span></div>
      </div>
      @if (isReorderProductLoading$ | async) {
        <loading class="pos-abs vh-center"></loading>
        }@if (!(isReorderProductLoading$ | async) && !(reorderProducts$ | async)?.length) {
        <div *ngTemplateOutlet="notFound"></div>
        }@if ((reorderProducts$ | async)?.length) {
        <product-carousel [products]="reorderProducts$ | async"></product-carousel>
      }
    </section>
  }
  <ng-template #notFound="">
    <div class="bold text-center pos-abs vh-center clr-secondary mT20" i18n="@@noProductsFound">
      No products found.
    </div>
  </ng-template>
</div>